import TemplateCreateDocumentForm1099 from './TemplateCreateDocumentForm1099'

export default TemplateCreateDocumentForm1099
